import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.075 13.42a.5.5 0 0 0 0 .7l1.686 1.72a.5.5 0 0 0 .714 0l5.382-5.49a.5.5 0 0 0 0-.7l-5.382-5.49a.5.5 0 0 0-.714 0l-1.686 1.72a.5.5 0 0 0 0 .7l3.01 3.07a.5.5 0 0 1 0 .7l-3.01 3.07Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.12 10.296a.424.424 0 0 1 0-.591L6.623 4.09a.404.404 0 0 1 .58 0l5.503 5.614c.16.163.16.427 0 .59L7.203 15.91a.404.404 0 0 1-.58 0L1.12 10.295Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=DoubleDiamondIcon20.js.map